import {Box} from "@mui/material";
// import toast from "react-hot-toast";
import {enqueueSnackbar} from "notistack";
import {useTranslation} from "react-i18next";
import {CopyToClipboard} from "react-copy-to-clipboard";
import RpIcon from "./RpIcon";

const CopyButton = ({color, value, size = 24, iconButtonProps}) => {
  const {t} = useTranslation("translation");

  const _onCopy = () => {
    enqueueSnackbar(t("copy_successful"), {
      variant: "success",
    });
  };

  return (
    <CopyToClipboard text={value} onCopy={_onCopy}>
      {/* <Tooltip title={t('copy')}> */}
      <Box>
        <RpIcon
          clickable
          color={color}
          icon={"copy"}
          size={size}
        ></RpIcon>
      </Box>
      {/* </Tooltip> */}
    </CopyToClipboard>
  );
};

export default CopyButton;
